import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetListFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_FREESPIN
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetListFreespinAction({
                    data: data.data.list,
                    countPage: data.data.countPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListFreespin as SetGetListFreespin
}